import { reduce } from 'lodash';

import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

export const extractFirstsBodyChildren = (
  numberOfSectionToDisplay: number,
  children?: DocumentItem[],
) => {
  let counter = 0;
  let shouldLoadMoreSection = true;

  return children
    ? reduce<DocumentItem, DocumentItem[]>(
        children,
        (acc, section) => {
          counter++;
          shouldLoadMoreSection =
            counter <= numberOfSectionToDisplay ||
            (shouldLoadMoreSection && section.shouldBeLazyLoaded === false);

          return shouldLoadMoreSection ? [...acc, section] : acc;
        },
        [],
      )
    : [];
};
